/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'

import React, { useEffect, useState } from 'react'
import NumberFormat from 'react-number-format'
import './styles.scss'
const roundTo = require('round-to')
const firebase = require('firebase/app')
require('firebase/database')

firebase.initializeApp({ databaseURL: 'https://zurich-hilft.firebaseio.com' })

export function Entry(props) {
  const [openForm, setOpenForm] = useState(false)
  const [messageSent, setMessageSent] = useState(false)

  let distance = null
  if (props.distance >= 1000) {
    distance = roundTo(props.distance / 1000, 1) + ' Kilometer'
  } else {
    distance = (
      <NumberFormat
        value={roundTo(props.distance, -2)}
        displayType='text'
        thousandSeparator="'"
        suffix=' Meter'
      />
    )
  }

  return (
    <div
      className={`resultentry ${
        props.activeFeature === props.id ? 'active' : ''
      }`}
      onClick={() => props.onClick()}
    >
      <p>
        <span className='name'>{props.title}</span>
        {/* <span className='entfernung'>ca. {distance} entfernt</span> */}
      </p>
      <p
        className='text'
        dangerouslySetInnerHTML={{
          __html: props.text.replace(/\n/g, '<br />')
        }}
      />
      <button
        className={`ui compact labeled ${
          messageSent ? 'positive' : ''
        } icon button formbutton`}
        onClick={() => setOpenForm(!openForm)}
      >
        <i className={`${messageSent ? 'check' : 'mail'} icon`} />
        Hilfe anbieten
      </button>

      {openForm && (
        <Contact
          parentid={props.id}
          globals={props.globals}
          setGlobals={g => props.setGlobals(g)}
          messageSent={() => {
            setOpenForm(false)
            setMessageSent(true)
          }}
        />
      )}
    </div>
  )
}

function Contact(props) {
  const [name, setName] = useState(props.globals.name)
  const [email, setEmail] = useState(props.globals.email)
  const [text, setText] = useState('')
  const [confirm, setConfirm] = useState(false)
  const [sent, setSent] = useState(false)

  useEffect(() => {
    props.setGlobals({ name, email })
  }, [name, email])

  const save = () => {
    const content = {
      name,
      email,
      text,
      timestamp: Date.now()
    }

    const path = `/data/${props.parentid}/helpers/`
    const newPostKey = firebase
      .database()
      .ref()
      .child(path)
      .push().key

    firebase
      .database()
      .ref(path + newPostKey)
      .update(content)
      .then(() => {
        console.log('Writing done')
      })
      .catch(e => {
        console.log('error', e)
      })

    props.messageSent()
    setSent(true)
  }

  return (
    <div className='ui form contactform'>
      <div className='field'>
        <label>Ihr Name</label>
        <input
          type='text'
          name='name'
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder='Max Musternamm'
        />
      </div>
      <div className='field'>
        <label>Ihre E-Mail-Adresse</label>
        <input
          type='text'
          name='email'
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder='max.mustermann@gmail.com'
        />
      </div>
      <div className='field required'>
        <label>Nachricht</label>
        <textarea
          rows={4}
          name='description'
          onChange={e => setText(e.target.value)}
          placeholder='Schreiben Sie hier in einigen Sätzen, wie Sie der Person helfen können.'
          defaultValue={text}
        />
      </div>
      <div className='ui checkbox'>
        <input
          type='checkbox'
          name='check'
          checked={confirm}
          onChange={() => setConfirm(!confirm)}
        />
        <label>
          Ich erkläre mich einverstanden, dass meine Daten an die hilfesuchende
          Person weitergeleitet werden.
        </label>
      </div>
      <button
        className={`ui ${!confirm ? 'disabled' : ''} positive button`}
        onClick={save}
      >
        Hilfe anbieten
      </button>
      {sent && (
        <div className='ui message' style={{ display: 'block' }}>
          <div className='header'>Vielen Dank!</div>
          <p>Ihre Nachricht wurde gespeichert</p>
        </div>
      )}
    </div>
  )
}

export default Entry
